import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-print",
  "use": "icon-print-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-print\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 390.4h-128V184.32A64 64 0 0 0 704 128H320a56.96 56.96 0 0 0-64 56.32V390.4H128a64 64 0 0 0-64 70.4V896h896V460.8a64 64 0 0 0-64-70.4zM320 184.32h384V390.4H320zM736 832h-448a32 32 0 0 1 0-64h448a32 32 0 0 1 0 64z m32-249.6a64 64 0 1 1 64-64 64 64 0 0 1-64 64z\" p-id=\"1086\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol